import type { NurtureStage, ProspectNurtureFields, ProspectNurtureFieldsUpdate } from '@/types/prospect-nurture';

export function buildNurtureUpdatePayload(data: ProspectNurtureFieldsUpdate): Record<string, unknown> {
  const updateData: Record<string, unknown> = {};

  if (data.nurture_stage !== undefined) updateData.nurture_stage = data.nurture_stage;
  if (data.nurture_opt_out !== undefined) updateData.nurture_opt_out = data.nurture_opt_out;
  if (data.nurture_opt_out_at !== undefined) updateData.nurture_opt_out_at = data.nurture_opt_out_at;
  if (data.nurture_paused_at !== undefined) updateData.nurture_paused_at = data.nurture_paused_at;
  if (data.nurture_notes !== undefined) {
    updateData.nurture_notes = data.nurture_notes?.trim() || null;
  }

  return updateData;
}

export function nurtureStageForDealClose(stage: string): NurtureStage | null {
  if (stage === 'closed_won') return 'exited_won';
  return null;
}

export function nurtureStageForBlueprintConversion(status: string): NurtureStage | null {
  if (status === 'converted' || status === 'qualified') return 'qualified';
  return null;
}

export function isNurtureActive(stage: NurtureStage, optOut: boolean): boolean {
  if (optOut || stage === 'opted_out' || stage === 'exited_won') return false;
  return true;
}

export function resolveNurtureFields(
  source: Partial<ProspectNurtureFields> | null | undefined
): ProspectNurtureFields {
  return {
    nurture_stage: source?.nurture_stage ?? 'new',
    nurture_opt_out: source?.nurture_opt_out ?? false,
    nurture_opt_out_at: source?.nurture_opt_out_at ?? null,
    nurture_paused_at: source?.nurture_paused_at ?? null,
    nurture_notes: source?.nurture_notes ?? null,
  };
}
